import { FirebaseDocRefType, FirebaseDocumentDataType } from 'firebase/index'
import { CheckoutItemType } from 'types/checkoutItem'
import { fetchCheckoutItemsByRef } from 'reducks/checkout/operations'

const mergeCheckoutItems = async (
  snapshots: FirebaseDocumentDataType,
  breadRefs: FirebaseDocRefType[]
): Promise<CheckoutItemType[]> => {
  const itemPromises = []
  for (let i = 0; i < snapshots.docs.length; i = (i + 1) | 0) {
    const snapshot = snapshots.docs[i]
    itemPromises.push(fetchCheckoutItemsByRef(snapshot.ref, breadRefs))
  }
  const result = await Promise.all(itemPromises).catch((error) => {
    throw new Error(`注文商品の一括取得に失敗: ${error}`)
  })
  return result.reduce((prev, _items) => [...prev, ..._items], [])
}

export default mergeCheckoutItems
